export default "__VITE_ASSET__BX6yAxh7__"